<template>
    <div class="youhuiquanZz" :class="{ active: isShowYouhuiquan }">
        <div class="youhuiquanBox">
            <div class="youhuiquan">
                <div class="title">优惠券</div>
                <div class="contentBox">
                    <div class="nickname">{{ nickname }}</div>
                    <div class="notice">
                        {{ sendMessage }}
                    </div>
                    <div class="couponBox">
                        <div
                            class="priceBox xianjin"
                            v-if="youhuiType == 'XIANJIN'"
                        >
                            <span class="unit">￥</span>
                            <span class="price">{{ manjianConfig.jian }}</span>
                        </div>
                        <div
                            class="priceBox manjian"
                            v-if="youhuiType == 'MANJIAN'"
                        >
                            <div class="top">满{{ manjianConfig.man }}减</div>
                            <div>
                                <span class="unit">￥</span>
                                <span class="price">{{
                                    manjianConfig.jian
                                }}</span>
                            </div>
                        </div>
                        <div class="name">
                            {{ youhuiType == "XIANJIN" ? "现金券" : "满减券" }}
                        </div>
                    </div>
                    <div class="explain">{{ instruction }}</div>
                    <div class="time">有效日期：{{ expireDate }}</div>
                </div>
            </div>
            <img
                @click="close()"
                class="close"
                src="~@/assets/close.png"
                alt=""
            />
        </div>
    </div>
</template>
<script>
    import rx from "../../_rx";
    import couponService from "../../service/coupon.service";
    export default {
        name: "youhuiquan",
        data() {
            return {
                isShowYouhuiquan: false,
                id: "",
                youhuiType: "",
                instruction: "",
                sendMessage: "",
                nickname: "",
                expireDate: "",
            };
        },
        mounted() {
            rx.on("showYouhuiquan", () => {
                this.rushCoupon();
            });
        },
        methods: {
            rushCoupon() {
                couponService.rushCoupon().then((res) => {
                    if (res.data.detail) {
                        this.id = res.data.detail.id;
                        if (this.id) {
                            this.isShowYouhuiquan = true;
                        }
                        this.youhuiType = res.data.detail.youhuiType;
                        this.instruction = res.data.detail.instruction;
                        this.manjianConfig = res.data.detail.manjianConfig;
                        this.sendMessage = res.data.detail.sendMessage;
                        this.nickname = res.data.nickname;
                        this.expireDate = res.data.detail.expireDate;
                    }
                });
            },

            close() {
                this.isShowYouhuiquan = false;
            },
        },
    };
</script>

<style lang="scss" scoped src="./youhuiquan.scss"></style>
